// src/Services/companyReceivingAccountService.js
import axiosInstance from "./api/axiosInstance";

/** Rótulos amigáveis para o tipo da chave PIX (o backend retorna o enum em maiúsculas). */
const PixKeyTypeLabels = {
  CNPJ: "CNPJ",
  EMAIL: "E-mail",
  CHAVE_ALEATORIA: "Chave Aleatória",
  TELEFONE: "Telefone",
};

/**
 * Busca as contas de recebimento ATIVAS da empresa para exibição ao cliente.
 * @returns {Promise<Array>} Lista de contas ativas.
 */
const getActiveAccounts = async () => {
  const response = await axiosInstance.get("companyreceivingaccount/active");
  return response.data;
};

export const companyReceivingAccountService = {
  getActiveAccounts,
  PixKeyTypeLabels,
};
